import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizer',
  standalone: true,
})
export class SanitizerPipe implements PipeTransform {
  _sanitizer = inject(DomSanitizer);

  transform(value: string): unknown {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
